
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const LoadingState: React.FC = () => {
  return (
    <div className="text-center py-12">
      <p className="text-xl text-muted-foreground">Loading article...</p>
    </div>
  );
};

export const NotFoundState: React.FC = () => {
  return (
    <div className="text-center py-12">
      <p className="text-xl text-muted-foreground">Article not found.</p>
      <Link to="/blog" className="inline-flex items-center mt-4 text-primary hover:underline">
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back to Blog
      </Link>
    </div>
  );
};
